<mat-toolbar color="accent">Edit Device Settings</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content>
    <div class="flex flex-auto flex-col">
      <json-editor formControlName="settings" [options]="editorOptions" />
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="flex grow"></div>
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="form.invalid"
    >
      Submit
    </button>
  </mat-dialog-actions>
</form>
